import { render, staticRenderFns } from "./CategoriaArgumentario.vue?vue&type=template&id=448e5188&scoped=true"
import script from "./CategoriaArgumentario.vue?vue&type=script&lang=js"
export * from "./CategoriaArgumentario.vue?vue&type=script&lang=js"
import style0 from "./CategoriaArgumentario.vue?vue&type=style&index=0&id=448e5188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e5188",
  null
  
)

export default component.exports